import { Phone, Mail, MapPin, Instagram, Linkedin } from 'lucide-react';
import { useState } from 'react';

const Footer = () => {
  const [hoveredSocial, setHoveredSocial] = useState(null);

  return (
    <div className="bg-black text-white py-12 sm:py-16 px-4 sm:px-6 border-t-4" style={{ borderTopColor: '#D4AF37' }}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-10 sm:mb-12 text-center">Get In Touch</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Phone */}
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full mb-4" style={{ backgroundColor: '#D4AF37' }}>
              <Phone className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Call Us</h3>
            <p className="text-white/90 text-base sm:text-lg font-medium">+91 97408 77727</p>
            <p className="text-white/70 text-sm sm:text-base mt-1">Mon-Sat, 9AM - 7PM IST</p>
          </div>

          {/* Email */}
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full mb-4" style={{ backgroundColor: '#D4AF37' }}>
              <Mail className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Email Us</h3>
            <p className="text-white/90 text-sm sm:text-base break-words">support@thehautecircle.com</p>
          </div>

          {/* Address */}
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full mb-4" style={{ backgroundColor: '#D4AF37' }}>
              <MapPin className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">Visit Us</h3>
            <p className="text-white/90 text-sm sm:text-base">36, ITPL Main Road, Brookefield,</p>
            <p className="text-white/90 text-sm sm:text-base">Bengaluru, Karnataka, 560037</p>
          </div>

          {/* Social Media */}
          <div className="text-center">
            <h3 className="text-lg sm:text-xl font-bold mb-5 sm:mb-6">Follow Us</h3>
            <div className="flex justify-center space-x-4 sm:space-x-5">
              {/* Instagram */}
              <div 
                className="relative"
                onMouseEnter={() => setHoveredSocial('instagram')}
                onMouseLeave={() => setHoveredSocial(null)}
              >
                <button className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full transition-colors cursor-pointer" 
                  style={{ 
                    backgroundColor: hoveredSocial === 'instagram' ? '#D4AF37' : 'white' 
                  }}>
                  <Instagram className="w-6 h-6 sm:w-7 sm:h-7 text-black" />
                </button>
                {hoveredSocial === 'instagram' && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-white text-black text-xs font-semibold rounded shadow-lg whitespace-nowrap z-10">
                    Coming Soon on Socials
                  </div>
                )}
              </div>

              {/* LinkedIn */}
              <div 
                className="relative"
                onMouseEnter={() => setHoveredSocial('linkedin')}
                onMouseLeave={() => setHoveredSocial(null)}
              >
                <button className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-full transition-colors cursor-pointer"
                  style={{ 
                    backgroundColor: hoveredSocial === 'linkedin' ? '#D4AF37' : 'white' 
                  }}>
                  <Linkedin className="w-6 h-6 sm:w-7 sm:h-7 text-black" />
                </button>
                {hoveredSocial === 'linkedin' && (
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-white text-black text-xs font-semibold rounded shadow-lg whitespace-nowrap z-10">
                    Coming Soon on Socials
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Privacy Policy & Terms and Conditions */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-8">
            <a 
              href="/privacy-policy" 
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              Privacy Policy
            </a>
            <span className="hidden sm:inline text-white/40">|</span>
            <a 
              href="/terms-and-conditions" 
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              Terms and Conditions
            </a>
          </div>
          <p className="text-center text-white/50 text-xs mt-4">
            © {new Date().getFullYear()} The Haute Circle. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
